// NeverTranslateModal.tsx
// NOTE: Update frontend/src/__tests__/NeverTranslateModal.test.tsx and run
// `../scripts/test-frontend.sh NeverTranslateModal` whenever this component changes.
import React from 'react';
import GlossaryRuleModal from './GlossaryRuleModal';

interface NeverTranslateModalProps {
  seriesGlossaryStatus?: import('./hooks/useSeriesGlossary').SeriesGlossaryStatus;
  onRefreshSeriesGlossary?: () => void;
  isVisible: boolean;
  onClose: () => void;
  currentLanguagePair: string;
  neverTranslateWords: { [key: string]: string[] };
  seriesNeverTranslateWords?: { [key: string]: string[] };
  alwaysTranslateWords?: { [key: string]: string[] };
  seriesAlwaysTranslateWords?: { [key: string]: string[] };
  setNeverTranslateWords: React.Dispatch<React.SetStateAction<{ [key: string]: string[] }>>;
  setSeriesTranslateRules?: React.Dispatch<
    React.SetStateAction<{
      alwaysTranslate: Record<string, string[]>;
      neverTranslate: Record<string, string[]>;
    }>
  >;
  selectedSeriesId?: string | null;
  resolvedUserId?: string;
  apiBase?: string;
  bookGuid: string;
  onSwitchRuleType?: (nextRuleType: 'always' | 'never') => void;
}

const NeverTranslateModal: React.FC<NeverTranslateModalProps> = (props) => (
  <GlossaryRuleModal ruleType="never" {...props} />
);

export default NeverTranslateModal;
